import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginButton from './components/LoginButton';
import Dashboard from './components/Dashboard';
import ApplicationForm from './components/ApplicationForm';
import ComplaintForm from './components/ComplaintForm';
import AdminPanel from './components/AdminPanel';
import MaintenanceNotice from './components/MaintenanceNotice';
import UnitLayout from './components/UnitLayout';
import UnitSelect from './components/UnitSelect';
import UnitsOverview from './components/UnitsOverview';
import { ToastProvider } from './context/ToastContext';
import { DialogProvider } from './components/Dialog';
import { useAuth } from './utils/auth';

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return <div className="loading">Ładowanie...</div>;
  }
  return isAuthenticated ? children : <Navigate to="/" replace />;
}

function App() {
  return (
    <ToastProvider>
      <DialogProvider>
        <BrowserRouter>
          <div className="app">
            <MaintenanceNotice />
            <div className="app-content">
              <Routes>
                <Route path="/" element={<LoginButton />} />
                <Route
                  path="/jednostki"
                  element={
                    <ProtectedRoute>
                      <UnitSelect />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/jednostki/overview"
                  element={
                    <ProtectedRoute>
                      <UnitsOverview />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/:unit"
                  element={
                    <ProtectedRoute>
                      <UnitLayout />
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<Navigate to="dashboard" replace />} />
                  <Route path="dashboard" element={<Dashboard />} />
                  <Route path="application" element={<ApplicationForm />} />
                  <Route path="complaint" element={<ComplaintForm />} />
                  <Route path="admin" element={<AdminPanel />} />
                </Route>
                <Route path="/dashboard" element={<Navigate to="/mp/dashboard" replace />} />
                <Route path="/application" element={<Navigate to="/mp/application" replace />} />
                <Route path="/complaint" element={<Navigate to="/mp/complaint" replace />} />
                <Route path="/admin" element={<Navigate to="/mp/admin" replace />} />
              </Routes>
            </div>
          </div>
        </BrowserRouter>
      </DialogProvider>
    </ToastProvider>
  );
}

export default App;
